import { ROUTE } from "../../../routes";
import AsyncStorage from '@react-native-async-storage/async-storage';
export const faqDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    await (navigate(ROUTE.FAQ_DETAILS, {
        title: action.payload.value
    }));
};
export const contact = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    await (navigate(ROUTE.CONTACT_US));
};
export const accountDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
};
export const goBack = async (action, _datastore, { goBack }) => {
    await AsyncStorage.setItem("prevRoute", ROUTE.FAQ);
    goBack();
};
